import { Box, Image } from '@chakra-ui/react';
import { List } from './List';
import log from '../../assets/new_logo.png';
const Landing = () => {
	return (
		<Box bg='#202020' w='full' margin='0!important' p={0}>
			<Image src={log} w='full' />
			<List />
		</Box>
	);
};

export default Landing;
